import React from "react";
import { Link } from "react-router-dom";
import { formatDateAndTime, serverLink, shortCode } from "../../../../resources/url";

function SideSearch(props) {
    const bottomClicked = async (item) => {
        const newsData = { ...item };
        props.setGeneralDetails(newsData);
        props.channgeScreen(item);
    };

    return (
        <div className="">

            <div className="blog-sidebar">
                <div className="widget">
                    <div className="widget-title">
                        <h5>Search</h5>
                    </div>
                    <form className="navbar-form search d-flex">
                        <input type="text" name="q" className="form-control input-search rounded-0 bg-white" placeholder="Search" onChange={props.handleSearch} autoComplete="off" />
                        <a><i className="fa fa-search text-white" /></a>
                    </form>
                </div>
                {props.newsList.length > 0 ? (
                    <div className="widget">

                        <div className="widget-title">
                            <h5>Related News</h5>
                        </div>
                        {props.newsList3.sort((a, b) => a.InsertedDate - b.InsertedDate).slice(0, 5)
                            .sort(() => Math.random() - 0.5)
                            .map((item, key) => {
                                return (
                                    <div className="media mb-3 pb-3 border-bottom" key={key}>

                                        <div className="media mb-3 pb-3 border-bottom">
                                            <Link to={`/news/${item.Slug}`}>
                                                <img className="img-fluid avatar border-radius"
                                                    src={item.ImagePath !== null ? item.ImagePath.includes("simplefileupload") ? item.ImagePath : `${serverLink}public/uploads/${shortCode}/news_uploads/${item.ImagePath}` : ""}
                                                    onClick={() => bottomClicked(item)}
                                                    alt="Image"
                                                />
                                            </Link>
                                            <div className="media-body ml-3">
                                                <Link to={`/news/${item.Slug}`}>
                                                    <span onClick={() => bottomClicked(item)}>
                                                        {" "}
                                                        {item.Title}{" "}
                                                    </span>{" "}
                                                </Link>
                                                <div className="events-meta">
                                                    <ul className="list-unstyled mb-0 d-flex">
                                                        <li><i className="fas fa-calendar-alt text-danger" /> {formatDateAndTime(item.InsertedDate, "date")}</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                );
                            })}
                    </div>
                ) : (
                    ""
                )}
            </div>

        </div>
    );
}

export default SideSearch;
